import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Button, Col, Row } from 'reactstrap';
import './PowerGrid.scss';

const { SearchBar } = Search;

class PowerGrid extends Component {

  constructor(props) {
    super(props);

    if (this.props.rowDoubleClickAction != null) {
      this.rowEvents = {
        onDoubleClick: (e, row, rowIndex) => this.props.rowDoubleClickAction(row, rowIndex, e)
      };
    }

    let headerClasses = this.props.actionClass ? this.props.actionClass : 'column-actions';

    this.actionsColumn =
    {
      dataField: 'actions',
      text: 'Actions',
      isDummyField: true,
      formatter: this.renderRowActions.bind(this),
      headerClasses: headerClasses,
      editable: false
    };

  }

  renderRowActions(cell, row, rowIndex) {
    return (
      <div>
        {
          this.props.rowActions.map((action, actionIndex) => {
            return action.render
              ? action.render(row, actionIndex, rowIndex)
              : (<Button key={actionIndex} className="mr-2" size="sm" color="ghost-primary" onClick={() => action.action(row, actionIndex)} >{action.dynamicLabel ? action.dynamicLabel(row) : action.label}</Button>)
          })
        }
      </div>
    )
  }

  setCellEditable() {
    if (this.props.cellEdit) {
      return cellEditFactory({ mode: 'click', blurToSave: true });
    }
    return cellEditFactory({ mode: null });
  }

  onSortGrid(field, order) {
    let sort = [{
      dataField: field,
      order: order
    }];
    sessionStorage.setItem(PowerGrid.orderStorageKey(), JSON.stringify(sort));
  }

  onSizePageChange = (sizePerPage, page) => {
    sessionStorage.setItem(PowerGrid.pageStorageKey(), page);
    localStorage.setItem(PowerGrid.sizePageStorageKey(), sizePerPage);
  }

  static clearStorageCache() {
    sessionStorage.removeItem(PowerGrid.searchStorageKey());
    sessionStorage.removeItem(PowerGrid.orderStorageKey());
    sessionStorage.removeItem(PowerGrid.pageStorageKey());
  }

  static searchStorageKey() {
    return 'powergrid-search';
  }

  static orderStorageKey() {
    return 'powergrid-order';
  }

  static sizePageStorageKey() {
    return 'powergrid-page-size';
  }

  static pageStorageKey() {
    return 'powergrid-page';
  }

  onSearchChange = (searchText) => {
    if (this.props.searchRemember) {
      sessionStorage.setItem(PowerGrid.searchStorageKey(), searchText);
    }
  }

  searchOptions() {
    if (this.props.search && this.props.searchRemember) {
      return {
        defaultSearch: sessionStorage.getItem(PowerGrid.searchStorageKey())
      };
    }

    return this.props.search;
  }

  defaultSorted() {
    let sortStorage = sessionStorage.getItem(PowerGrid.orderStorageKey());
    if (sortStorage) {
      return JSON.parse(sortStorage);
    }
    return this.props.defaultSorted;
  }

  paginationOptions() {
    if (this.props.pagination) {
      this.props.paginationOptions.onSizePerPageChange = this.onSizePageChange;

      let sizePage = localStorage.getItem(PowerGrid.sizePageStorageKey());
      if (sizePage) {
        this.props.paginationOptions.sizePerPage = parseInt(sizePage);
      }

      return paginationFactory(this.props.paginationOptions);
    }
    return null;
  }

  render() {

    return (
      <ToolkitProvider
        bootstrap4
        keyField={this.props.keyField}
        data={this.props.data}
        columns={this.props.rowActions.length > 0 ? [...this.props.columns, this.actionsColumn] : this.props.columns}
        search={this.searchOptions()}
      >
        {
          props => (
            <>
              {
                (this.props.toolbarActions.length > 0 || this.props.search) &&
                (<Row form className="mb-3">

                  <Col className="text-left">
                    {
                      this.props.leftToolbarActions.map((action, index) => {
                        return action.render
                          ? action.render(index)
                          : (<Button key={index} className="ml-2" color="primary" onClick={(event) => action.action(event)} >{action.dynamicLabel ? action.dynamicLabel(index) : action.label}</Button>)
                      })
                    }
                  </Col>
                  <Col className="text-right">
                    {
                      this.props.toolbarActions.map((action, index) => {
                        return action.render
                          ? action.render(index)
                          : (
                            <Button id={"toolbar-btn-" + index} key={index} className="ml-2" color="primary" disabled={action.disabled}
                              onClick={(event) => action.action(event)}
                              data-toggle="tooltip" data-placement="top" title={action.tooltip}>{action.dynamicLabel ? action.dynamicLabel(index) : action.label}</Button>
                          )
                      })
                    }
                  </Col>
                  <Col lg="3">
                    {
                      this.props.searchActions.map((action, index) => {
                        return action.render
                          ? action.render(index)
                          : this.props.search && !this.props.disableSearchBar &&
                          (
                            <SearchBar className="powergrid-search-input"
                              {...props.searchProps}
                              onSearch={(searchText) => {
                                this.onSearchChange(searchText); // first, save the value searched in the session storage
                                props.searchProps.onSearch(searchText); //then, execute the search to filter the table
                              }}
                              ref={this.searchBar} />
                          )
                      })
                    }
                  </Col>
                </Row>
                )}

              <BootstrapTable
                {...props.baseProps}
                // striped
                bordered={false}
                hover
                // condensed
                defaultSorted={this.defaultSorted()}
                pagination={this.props.paginationOptions} // get by parameter
                cellEdit={this.setCellEditable()}
                rowEvents={this.rowEvents}
                filter={filterFactory()}
                selectRow={this.props.selectRow.enabled ? this.props.selectRow : undefined}
              />
            </>
          )
        }
      </ToolkitProvider>
    );

  }
}

const ActionType = PropTypes.shape({
  label: PropTypes.string,
  dynamicLabel: PropTypes.func,
  action: PropTypes.func,
  render: PropTypes.func,
  paginationOptions: PropTypes.func
});

PowerGrid.propTypes = {
  pagination: PropTypes.bool,
  cellEdit: PropTypes.bool,
  search: PropTypes.bool,
  searchRemember: PropTypes.bool,
  toolbarActions: PropTypes.arrayOf(ActionType),
  leftToolbarActions: PropTypes.arrayOf(ActionType),
  rowActions: PropTypes.arrayOf(ActionType),
  rowDoubleClickAction: PropTypes.func,
  actionClass: PropTypes.string
}

PowerGrid.defaultProps = {
  search: true,
  disableSearchBar: false,
  searchRemember: false,
  searchActions: [],
  toolbarActions: [],
  leftToolbarActions: [],
  rowActions: [],
  cellEdit: false,
  pagination: true,
  selectRow: {
    mode: 'checkbox',
    clickToSelect: true,
    style: { backgroundColor: '#d6f4ff' }
  }

}

export default PowerGrid;
